import React, { Component } from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Paper,
    Typography,
} from '@mui/material';
import SectionTitle from './SectionTitle';
import { ALERT_SEVERITY } from '../../../../../components/AlertDisplay2';

const borderColor = 'rgba(211,211,211,0.91)';

const PICKER_DATE_RESOURCE = {
    STARTDATE: 0,
    ENDDATE: 1,
};

const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;

class ValidTimeRangeSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pickerDate: new Date(),
            minimumDate: null,
            maximumDate: null,
            pickerOpen: false,
            currentDateResource: null,
        };
    }

    getTomorrow = () => {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        d.setDate(d.getDate() + 1);
        return d;
    };

    getDayAfterTomorrow = () => {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        d.setDate(d.getDate() + 2);
        return d;
    };

    getLaterDate = (a, b) => {
        if (!a) return b || null;
        if (!b) return a || null;
        return a.getTime() > b.getTime() ? a : b;
    };
    openPicker = (pDataResource) => {
        const { startDate, endDate, editMode, minDate, showAlert } = this.props;

        if (editMode) {
            // window.alert('Die Daten können nicht bearbeitet werden.');
            showAlert('Die Daten können nicht bearbeitet werden.', ALERT_SEVERITY.WARNING);
            return;
        }

        let pickerDate = new Date();
        let minPickerDate = null;
        let maxPickerDate = null;

        const tomorrow = this.getTomorrow();
        const dayAfterTomorrow = this.getDayAfterTomorrow();
        const externalMinDate = minDate ? new Date(minDate) : null;

        if (externalMinDate) {
            externalMinDate.setHours(0, 0, 0, 0);
        }

        switch (pDataResource) {
            case PICKER_DATE_RESOURCE.STARTDATE: {
                pickerDate = startDate != null ? new Date(startDate.getTime()) : new Date(tomorrow.getTime());

                // start date must be at least tomorrow
                minPickerDate = tomorrow;

                // if external minDate is later, use that
                minPickerDate = this.getLaterDate(minPickerDate, externalMinDate);

                // start must stay before end
                if (endDate != null) {
                    maxPickerDate = new Date(endDate.getTime() - ONE_DAY_IN_MS);
                    maxPickerDate.setHours(0, 0, 0, 0);
                }

                // keep initially shown picker date inside valid range
                if (pickerDate < minPickerDate) {
                    pickerDate = new Date(minPickerDate.getTime());
                }
                if (maxPickerDate && pickerDate > maxPickerDate) {
                    pickerDate = new Date(maxPickerDate.getTime());
                }
                break;
            }

            case PICKER_DATE_RESOURCE.ENDDATE: {
                pickerDate = endDate != null ? new Date(endDate.getTime()) : new Date(dayAfterTomorrow.getTime());

                // end date must be at least two days from now
                minPickerDate = dayAfterTomorrow;

                // if startDate exists, end date must be at least start + 1 day
                if (startDate != null) {
                    const startPlusOne = new Date(startDate.getTime() + ONE_DAY_IN_MS);
                    startPlusOne.setHours(0, 0, 0, 0);
                    minPickerDate = this.getLaterDate(minPickerDate, startPlusOne);
                }

                // if external minDate is later, use that
                minPickerDate = this.getLaterDate(minPickerDate, externalMinDate);

                if (pickerDate < minPickerDate) {
                    pickerDate = new Date(minPickerDate.getTime());
                }
                break;
            }

            default:
                pickerDate = new Date(tomorrow.getTime());
        }

        pickerDate.setHours(0, 0, 0, 0);

        this.setState({
            pickerOpen: true,
            currentDateResource: pDataResource,
            pickerDate,
            minimumDate: minPickerDate,
            maximumDate: maxPickerDate,
        });
    };

    formatDate = (date) => {
        if (!date) return '-';

        return new Date(date).toLocaleDateString('de-DE', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });
    };

    formatDateForInput = (date) => {
        if (!date) return '';

        const d = new Date(date);
        const year = d.getFullYear();
        const month = `${d.getMonth() + 1}`.padStart(2, '0');
        const day = `${d.getDate()}`.padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    parseInputDate = (value) => {
        if (!value) return null;

        const [year, month, day] = value.split('-').map(Number);
        return new Date(year, month - 1, day);
    };

    handleConfirm = () => {
        const { setStartDate, setEndDate } = this.props;
        const { currentDateResource, pickerDate } = this.state;

        if (!pickerDate) {
            this.setState({ pickerOpen: false });
            return;
        }

        if (currentDateResource === PICKER_DATE_RESOURCE.STARTDATE) {
            setStartDate?.(pickerDate);
        } else {
            setEndDate?.(pickerDate);
        }

        this.setState({ pickerOpen: false });
    };

    renderPickerButton = ({ label, value, onClick, singleMode, showLabel = true }) => {
        return (
            <Box
                onClick={onClick}
                sx={{
                    flex: 1,
                    px: 2,
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    minHeight: 56,
                    gap: 1,
                }}
            >
                <Box
                    component="img"
                    src={require('../../../../../assets/icons/timeandcalendar.png')}
                    alt=""
                    sx={{ width: 20, height: 20, objectFit: 'contain' }}
                />

                {!singleMode && showLabel && (
                    <Typography sx={{ fontSize: 14 }}>
                        {label}:
                    </Typography>
                )}

                <Typography
                    sx={{
                        flex: 1,
                        textAlign: 'right',
                        fontSize: 14,
                    }}
                >
                    {this.formatDate(value)}
                </Typography>
            </Box>
        );
    };

    render() {
        const {
            startDate,
            endDate,
            setStartDate,
            setEndDate,
            noDelete,
            singleMode,
            title,
            icon,
        } = this.props;

        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                <SectionTitle
                    icon={icon || require('../../../../../assets/icons/hourglass.png')}
                    label={title || 'Gültigkeit'}
                />

                <Paper
                    variant="outlined"
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        borderColor,
                        borderRadius: 1,
                        overflow: 'hidden',
                    }}
                >
                    {this.renderPickerButton({
                        label: 'Von',
                        value: startDate,
                        onClick: () => this.openPicker(PICKER_DATE_RESOURCE.STARTDATE),
                        singleMode,
                        showLabel: !singleMode,
                    })}

                    {!singleMode && (
                        <>
                            <Box sx={{ width: '1px', backgroundColor: borderColor }} />
                            {this.renderPickerButton({
                                label: 'Bis',
                                value: endDate,
                                onClick: () => this.openPicker(PICKER_DATE_RESOURCE.ENDDATE),
                                singleMode: false,
                                showLabel: true,
                            })}
                        </>
                    )}
                </Paper>

                <Dialog
                    open={this.state.pickerOpen}
                    onClose={() => this.setState({ pickerOpen: false })}
                    fullWidth
                    maxWidth="xs"
                >
                    <DialogTitle>Datum auswählen</DialogTitle>

                    <DialogContent>
                        <Box sx={{ pt: 1 }}>
                            <input
                                type="date"
                                value={this.formatDateForInput(this.state.pickerDate)}
                                min={this.state.minimumDate ? this.formatDateForInput(this.state.minimumDate) : undefined}
                                max={this.state.maximumDate ? this.formatDateForInput(this.state.maximumDate) : undefined}
                                onChange={(e) => {
                                    const nextDate = this.parseInputDate(e.target.value);
                                    if (nextDate) {
                                        this.setState({ pickerDate: nextDate });
                                    }
                                }}
                                style={{
                                    width: '100%',
                                    height: '42px',
                                    border: '1px solid #ccc',
                                    borderRadius: '6px',
                                    padding: '0 12px',
                                    fontSize: '14px',
                                    boxSizing: 'border-box',
                                }}
                            />
                        </Box>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={() => this.setState({ pickerOpen: false })}>
                            Abbrechen
                        </Button>
                        <Button variant="contained" onClick={this.handleConfirm}>
                            Bestätigen
                        </Button>
                    </DialogActions>
                </Dialog>

                {(startDate != null || endDate != null) && !noDelete && (
                    <Button
                        variant="outlined"
                        color="error"
                        onClick={() => {
                            setStartDate?.(null);
                            setEndDate?.(null);
                        }}
                        sx={{
                            alignSelf: 'flex-start',
                        }}
                    >
                        Löschen
                    </Button>
                )}
            </Box>
        );
    }
}

export default ValidTimeRangeSection;